import React from "react";
import { Link } from "react-router-dom";
import "../static/css/AdminNav.css";

function AdminNav() {
  return (
    <>
      <div className="admin-Nav">
        <div className="adminNav-title">
          SPP
        </div>
        <div className="adminNav-button">
          <Link to="/adminpublications">Publications</Link>

          <Link to="/adminteam">Team Members</Link>
          <Link to="/admininsolvencycases">Insolvency Cases</Link>
          <Link to="/admincontrol">Admin Users</Link>
        </div>
      </div>
    </>
  );
}

export default AdminNav;
